import { render, staticRenderFns } from "./PlanCtaPill.vue?vue&type=template&id=2771f1da"
import script from "./PlanCtaPill.vue?vue&type=script&setup=true&lang=ts"
export * from "./PlanCtaPill.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports